/* ======================================================================== */
/* 53. SliderHalfScreen */
/* ======================================================================== */
var SliderHalfScreen = function ($slider) {

	if (!$slider.length) {
		return;
	}

	var
		$heading = $slider.find('h2'),
		$description = $slider.find('p'),
		$link = $slider.find('.slider-halfscreen__wrapper-link'),
		$linksHover = $slider.find('.slider-halfscreen__link'),
		tl = new TimelineMax(),
		$sliderImg = $slider.find('.js-slider-halfscreen__images'),
		$sliderContent = $slider.find('.js-slider-halfscreen__content'),
		overlapFactor = $sliderImg.data('overlap-factor') || 0;

	createSliders();
	hoverLinks();

	function createSliders() {

		var sliderImg = new Swiper($sliderImg, {
			slidesPerGroup: 1,
			slidesPerView: 1,
			direction: 'vertical',
			preloadImages: true,
			lazy: {
				loadPrevNextAmount: 3,
				loadPrevNext: true,
				loadOnTransitionStart: true
			},
			speed: $sliderImg.data('speed') || 1200,
			simulateTouch: false,
			allowTouchMove: $sliderImg.data('touch-enabled') || false,
			watchSlidesProgress: true,
			on: {
				progress: function () {
					var swiper = this;
					for (var i = 0; i < swiper.slides.length; i++) {

						var slideProgress = swiper.slides[i].progress,
							innerOffset = swiper.height * overlapFactor,
							innerTranslate = slideProgress * innerOffset;

						try {
							TweenMax.set(swiper.slides[i].querySelector('.slider-halfscreen__bg'), {
								y: innerTranslate + 'px',
								rotationZ: 0.01,
								force3D: true
							});
						} catch (error) {

						}

					}
				},
				setTransition: function (speed) {
					var swiper = this;
					for (var i = 0; i < swiper.slides.length; i++) {
						try {
							TweenMax.set(swiper.slides[i], {
								transition: speed + 'ms',
							});
							TweenMax.set(swiper.slides[i].querySelector('.slider-halfscreen__bg'), {
								transition: speed + 'ms',
								rotationZ: 0.01,
								force3D: true
							});
						} catch (error) {

						}

					}
				}
			}
		});

		var sliderContent = new Swiper($sliderContent, {
			slidesPerGroup: 1,
			slidesPerView: 1, // compatibility with Swiper 5.x
			direction: 'vertical',
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			autoplay: {
				enabled: $sliderImg.data('autoplay-enabled') || false,
				delay: $sliderImg.data('autoplay-delay') || 6000,
			},
			mousewheel: $sliderImg.data('mousewheel-enabled') ? {
				eventsTarged: $sliderImg.data('mousewheel-target') || '.page-wrapper',
				releaseOnEdges: true,
			} : false,
			keyboard: {
				enabled: $sliderImg.data('keyboard-enabled') || false
			},
			navigation: {
				nextEl: '.js-slider-halfscreen__next',
				prevEl: '.js-slider-halfscreen__prev',
			},
			speed: $sliderImg.data('speed') || 1200,
			allowTouchMove: $sliderImg.data('touch-enabled') || false,
			simulateTouch: true,
			breakpointsInverse: true // compatibility with both Swiper 4.x and 5.x
		});

		sliderContent.params.breakpoints = {
			0: {
				autoHeight: true
			},
			992: {
				autoHeight: false
			}
		};

		sliderContent.update();


		sliderContent.on('slideChange', () => {

			if (sliderContent.realIndex > sliderContent.previousIndex) {
				slideChangeTransition('next');
			}

			if (sliderContent.realIndex < sliderContent.previousIndex) {
				slideChangeTransition('prev');
			}

		});

		function slideChangeTransition(direction = 'next') {

			var
				$activeSlide = $(sliderContent.slides[sliderContent.realIndex]),
				$activeHeading = $activeSlide.find($heading),
				$activeLink = $activeSlide.find($link),
				$activeDescription = $activeSlide.find($description);

			tl.clear();

			if ($activeHeading.length) {
				tl.add(hideWords($activeHeading, '0', '0', direction === 'next' ? '-50px' : '50px'), '0');
			}

			if ($heading.length) {
				$heading.not($activeHeading).each(function () {
					tl.add(hideWords($(this), 0.3, 0.02, direction === 'next' ? '50px' : '-50px', direction === 'next' ? true : false), '0');
				});
			}

			if ($activeDescription.length) {
				tl.add(hideLines($activeDescription, '0', '0', '100%'), '0');
			}

			if ($description.length) {
				$description.not($activeDescription).each(function () {
					tl.add(hideLines($(this), 0.6, 0.01, '100%', true), '0');
				});
			}

			if ($activeLink.length) {
				tl.set($activeLink, {
					y: '15px',
					autoAlpha: 0
				}, '0');
			}

			if ($link.length) {
				$link.not($activeLink).each(function () {
					tl.to($(this), 0.6, {
						y: '15px',
						autoAlpha: 0
					}, '0');
				});
			}

			tl
				.add(animateWords($activeHeading, 1.2, 0.02, direction === 'next' ? true : false))
				.add(animateLines($activeDescription, 1.2, 0.01, direction === 'next' ? true : false), '-=1.2')
				.to($activeLink, 0.6, {
					y: '0px',
					autoAlpha: 1
				}, '-=1.2');

		}

		sliderImg.controller.control = sliderContent;
		sliderContent.controller.control = sliderImg;

		/**
		 * Resize handling (with debounce)
		 */
		window.$window.on('resize', debounce(function () {
			if (typeof sliderImg === 'object') {
				sliderImg.update();
			}
			if (typeof sliderContent === 'object') {
				sliderContent.update();
			}
		}, 250));

	}

	function hoverLinks() {

		$linksHover
			.on('mouseenter touchstart', function () {

				var $targetBackground = $sliderImg.find('.swiper-slide-active .slider-halfscreen__images-slide-inner'),
					$linkLine = $sliderContent.find('.swiper-slide-active .slider-halfscreen__link-line');

				if (!$targetBackground.length) {
					return;
				}

				TweenMax.to($targetBackground, 0.6, {
					scale: 1.05,
					ease: Expo.easeInOut
				});

				TweenMax.to($linkLine, 0.6, {
					width: '70px',
					ease: Expo.easeInOut
				});

			})
			.on('mouseleave touchend', function () {

				var $targetBackground = $sliderImg.find('.swiper-slide-active .slider-halfscreen__images-slide-inner'),
					$linkLine = $sliderContent.find('.swiper-slide-active .slider-halfscreen__link-line');

				if (!$targetBackground.length) {
					return;
				}

				TweenMax.to($targetBackground, 0.6, {
					scale: 1,
					ease: Expo.easeInOut
				});

				TweenMax.to($linkLine, 0.6, {
					width: '60px',
					ease: Expo.easeInOut
				});

			});

	}

}
